import React from "react"
import { siteUrl } from "../../../shared/utils/siteUrl"
import NavigatorSteps from "../../atoms/navigator-steps/navigator-steps"
import "./steps-register.scss"

const StepsRegister = props => {
  return (
    <div className="f-stepRegister">
      <div className="f-stepRegister-content">
        <h1>
          ¿
          {process.env.LOCALE === "es-AR" ||
          process.env.LOCALE === "es-PY" ||
          process.env.LOCALE === "es-UY"
            ? "Sos nueva acá?"
            : "Eres nueva aquí?"}{" "}
        </h1>
        <h2>
          {process.env.LOCALE === "es-AR" ||
          process.env.LOCALE === "es-PY" ||
          process.env.LOCALE === "es-UY"
            ? "REGISTRATE"
            : "REGÍSTRATE"}
        </h2>
        <div className="f-stepRegister-content-wrap">
          <div className="f-stepRegister-content-step">{props.children}</div>
          <NavigatorSteps step={props.step} stepsLenght={props.stepsLenght} />
        </div>
        {props.step > 1 && (
          <div className="f-stepRegister-links">
            <div className="f-stepRegister-links-container right">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  siteUrl +
                  "/" +
                  props.termsContentful.redireccionPoliticaPrivacidadDatos
                }
              >
                {props.termsContentful.politicaPrivacidadDatos}
              </a>
            </div>
            <div className="f-stepRegister-links-container left">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  siteUrl +
                  "/" +
                  props.termsContentful.redireccionTerminosYCondiciones
                }
              >
                {props.termsContentful.terminosYCondiciones}
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default StepsRegister
